/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { UPDATE_STORE } from './graphql';

export function useUpdateStore() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [UpdateStore, { loading: apiLoading }] = useMutation(UPDATE_STORE, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    setIsLoading(apiLoading);
    setLoading(apiLoading);
  }, [apiLoading]);

  async function updateStore({ userId, store }) {
    setIsSuccess(false);
    try {
      const res = await UpdateStore({
        variables: {
          userId,
          store: {
            ...store,
            telephone: store.telephone.replace(/[^\d]+/g, ''),
          },
        },
      });
      if (res.data.updateStore.code === 200) {
        setIsSuccess(true);
        setSuccessMessage(res.data.updateStore.message);
      } else {
        setErrorMessage(res.data.updateStore.message);
      }
    } catch (e) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    }
  }

  return {
    updateStore,
    loading: isLoading,
    success: isSuccess,
  };
}
